
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyLateralCanRed as ObiSimplifiedBuoyLateralCanRedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-lateral-can-red.js';
 
 
 

 
 export const ObiSimplifiedBuoyLateralCanRed = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-lateral-can-red',
   elementClass: ObiSimplifiedBuoyLateralCanRedElement,
   events: {
     
   }
  });
 
 